<template>
  <div v-if="results.length" class="blog-featured-articles">
    <h2 class="h3">
      Featured Articles
    </h2>
    <div class="main">
      <ArticleCard
        :article="main"
        size="lg"
        type="horizontal"
      />
    </div>
    <div class="row subs">
      <ArticleCard
        v-for="(article, i) in subs"
        :key="i"
        :article="article"
        class="col col-4"
      />
    </div>
  </div>
</template>
<script>
import global from '@itbpbg/lms-components/src/mixins/global';
import ArticleCard from './ArticleCard';

export default {
  components: { ArticleCard },
  mixins: [global],
  props: {
    results: { type: Array, default: () => [], required: true },
  },
  computed: {
    main() {
      return this.results[0];
    },
    subs() {
      return this.results.slice(1);
    },
  },
};
</script>

<style scoped lang="scss">
.blog-featured-articles {
  margin-top: var(--spacing-48);

  .h3 {
    border-bottom: 1px solid rgba(0, 12, 31, 0.12);
    margin: 0 0 var(--spacing-24);
    padding-bottom: var(--spacing-16);
  }

  .row {
    align-items: center;

    @include bp($bp-mobile) {
      .list + .list {
        margin-top: 36px;
      }
    }
  }

  .main {
    margin-bottom: var(--spacing-48);
  }
}
</style>
